/** @format */
import { defineStore, StoreDefinition } from 'pinia';
import { store } from '@/store';
import defaultSettings from '@/enums/settings';
import { useDynamicTitle } from '@/utils/dynamicTitle';

const { sideTheme, showSettings, topNav, tagsView, fixedHeader, sidebarLogo, dynamicTitle } = defaultSettings;

const storageSetting = JSON.parse(window.localStorage.getItem('layout-setting') || '{}') || {};

const useSettingsStore: StoreDefinition = defineStore('settings', {
	state: () => ({
		title: '',
		theme: storageSetting.theme || '#409EFF',
		sideTheme: storageSetting.sideTheme || sideTheme,
		showSettings,
		topNav: storageSetting.topNav === undefined ? topNav : storageSetting.topNav,
		tagsView: storageSetting.tagsView === undefined ? tagsView : storageSetting.tagsView,
		fixedHeader: storageSetting.fixedHeader === undefined ? fixedHeader : storageSetting.fixedHeader,
		sidebarLogo: storageSetting.sidebarLogo === undefined ? sidebarLogo : storageSetting.sidebarLogo,
		dynamicTitle: storageSetting.dynamicTitle === undefined ? dynamicTitle : storageSetting.dynamicTitle,
	}),

	actions: {
		// 修改布局设置
		changeSetting(data) {
			const { key, value } = data;
			if (Object.prototype.hasOwnProperty.call(this, key)) {
				(this as any)[key] = value;
			}
		},
		// 设置网页标题
		setTitle(title) {
			this.title = title;
			useDynamicTitle();
		},
	},
});

export default useSettingsStore;

// 在组件setup函数外使用
export function useSettingsStoreWithOut(): any {
	return useSettingsStore(store);
}
